(function () {
  if (window.NNLazyVideo) {
    window.NNLazyVideo.schedule();
    return;
  }

  var VIDEO_SELECTOR = '[data-nn-lazy-video]';
  var INIT_ATTR = 'data-nn-lazy-video-init';
  var LOADED_ATTR = 'data-nn-lazy-video-loaded';
  var DEFAULT_BREAKPOINT = 1025;
  var breakpointQueries = {};
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getBreakpoint(video) {
    var value = parseInt(video.getAttribute('data-breakpoint'), 10);
    return Number.isFinite(value) ? value : DEFAULT_BREAKPOINT;
  }

  function getMediaQuery(video) {
    var breakpoint = getBreakpoint(video);
    var query = '(min-width: ' + breakpoint + 'px)';

    if (!breakpointQueries[query]) {
      breakpointQueries[query] = window.matchMedia(query);
    }

    return breakpointQueries[query];
  }

  function getSources(video) {
    var isDesktop = getMediaQuery(video).matches;
    var webm = isDesktop ? video.dataset.desktopWebmSrc : video.dataset.mobileWebmSrc;
    var mp4 = isDesktop ? video.dataset.desktopSrc : video.dataset.mobileSrc;

    if (!webm && isDesktop) {
      webm = video.dataset.mobileWebmSrc;
    }

    if (!mp4 && isDesktop) {
      mp4 = video.dataset.mobileSrc;
    }

    return {
      webm: webm || '',
      mp4: mp4 || ''
    };
  }

  function getPoster(video) {
    var isDesktop = getMediaQuery(video).matches;
    var poster = isDesktop ? video.dataset.desktopPoster : video.dataset.mobilePoster;

    if (!poster && isDesktop) {
      poster = video.dataset.mobilePoster;
    }

    return poster || '';
  }

  function applyPoster(video) {
    var poster = getPoster(video);

    if (!poster || video.getAttribute('poster') === poster) {
      return;
    }

    video.setAttribute('poster', poster);
  }

  function sourceKey(sources) {
    return sources.webm + '|' + sources.mp4;
  }

  function clearSources(video) {
    while (video.firstChild) {
      video.removeChild(video.firstChild);
    }
  }

  function appendSource(video, src, type) {
    if (!src) return;

    var source = document.createElement('source');
    source.src = src;
    source.type = type;
    video.appendChild(source);
  }

  function playVideo(video) {
    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function setSources(video, sources) {
    applyPoster(video);

    if (!sources.webm && !sources.mp4) {
      return;
    }

    var nextKey = sourceKey(sources);

    if (video.dataset.nnCurrentSourceKey === nextKey) {
      return;
    }

    clearSources(video);
    appendSource(video, sources.webm, 'video/webm');
    appendSource(video, sources.mp4, 'video/mp4');

    video.dataset.nnCurrentSourceKey = nextKey;
    video.setAttribute(LOADED_ATTR, 'true');
    video.load();
    playVideo(video);
  }

  function loadVideo(video) {
    if (!video) return;

    setSources(video, getSources(video));
  }

  function observeVideo(video) {
    applyPoster(video);

    if (reducedMotionQuery.matches) {
      return;
    }

    if (video.getAttribute(INIT_ATTR) === 'true') return;

    video.setAttribute(INIT_ATTR, 'true');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;

        loadVideo(video);
        observer.disconnect();
      }, {
        rootMargin: '600px 0px'
      });

      observer.observe(video);
      return;
    }

    loadVideo(video);
  }

  function init() {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(observeVideo);
  }

  function refreshLoadedVideos() {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
      applyPoster(video);

      if (video.getAttribute(LOADED_ATTR) === 'true' && !reducedMotionQuery.matches) {
        setSources(video, getSources(video));
      }
    });
  }

  function bindBreakpointListeners() {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
      var mediaQuery = getMediaQuery(video);

      if (mediaQuery.nnLazyVideoBound) return;

      mediaQuery.nnLazyVideoBound = true;

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', refreshLoadedVideos);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(refreshLoadedVideos);
      }
    });
  }

  function bindMotionListener() {
    if (reducedMotionQuery.nnLazyVideoBound) return;

    reducedMotionQuery.nnLazyVideoBound = true;

    var onMotionChange = function () {
      if (reducedMotionQuery.matches) {
        document.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
          video.pause();
        });
        return;
      }

      init();
      refreshLoadedVideos();
    };

    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', onMotionChange);
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(onMotionChange);
    }
  }

  function runAfterLoad() {
    var run = function () {
      bindMotionListener();
      bindBreakpointListeners();
      init();
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1500 });
      return;
    }

    window.setTimeout(run, 250);
  }

  function schedule() {
    if (document.readyState === 'complete') {
      runAfterLoad();
      return;
    }

    window.addEventListener('load', runAfterLoad, { once: true });
  }

  window.NNLazyVideo = {
    init: init,
    load: loadVideo,
    schedule: schedule
  };

  schedule();

  document.addEventListener('shopify:section:load', schedule);
})();
